import React from "react";

import { Box, Button, IconButton, Typography } from "@mui/material";

import CloseIcon from "icons/Close";

import useModal from "hooks/useModal";
import Modal from "components/common/Modal";
import { MODALS } from "components/common/Modal/utils";
import { formatSeconds } from "utils";

const modalId = MODALS.ttsRequestsLimit;

const TTSRequestsLimit = () => {
  const [open, data, handleClose] = useModal({ modalId });

  if (!open) {
    return <></>;
  }

  const retryTime = formatSeconds(data?.retryAfter || 43200, "H_m").split("_");

  return (
    <Modal
      open={open}
      onClose={handleClose}
      maxWidth="320px"
      contentSx={{
        p: "16px",
      }}
    >
      <IconButton
        variant="outlined"
        onClick={handleClose}
        sx={{
          position: "absolute",
          top: "16px",
          right: "16px",
          zIndex: 1,
          background: "var(--surface-elements-elevation-high)",
        }}
      >
        <CloseIcon />
      </IconButton>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "8px",
          pt: "48px",
        }}
      >
        <img
          src="/images/upgrade-plan-minutes.png"
          loading="lazy"
          width="280"
          height="200"
          style={{
            objectFit: "contain",
          }}
        />
        <Typography
          variant="h1"
          sx={{
            color: "var(--on-surface-primary)",
            fontSize: "24px",
            lineHeight: "32px",
            width: "100%",
          }}
        >
          Daily Limit Reached
        </Typography>
        <Typography variant="body2">
          You've hit your daily {data?.limit || 100}-request limit for
          Text-To-Speech (TTS) conversions, but You can still use
          Speech-To-Speech (STS) conversion.
        </Typography>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 16px",
            border: "1px solid var(--surface-outlines)",
            borderRadius: "8px",
            background: "var(--surface-elements-elevation-high)",
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontSize: "12px", fontWeight: 400 }}
          >
            Daily Limit will be reset in
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontSize: "12px", fontWeight: 400 }}
          >
            {`${retryTime[0]}h ${retryTime[1]}m`}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          mt: "24px",
          gap: "8px",
        }}
      >
        <Button
          variant="contained"
          onClick={() => handleClose()}
          sx={{ flexGrow: 1 }}
        >
          Got It
        </Button>
      </Box>
    </Modal>
  );
};

TTSRequestsLimit.propTypes = {};

export default TTSRequestsLimit;
